'use strict';
'use es6';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.SimpleDateType = undefined;

var _react = require('react');

/**
 * PropType function that can be used with React components to validate objects
 * shaped like a "SimpleDate"
 *
 * type SimpleDate = {
 *   year: number;
 *   month: number;
 *   date: number;
 * };
 */
var SimpleDateType = exports.SimpleDateType = _react.PropTypes.shape({
  year: _react.PropTypes.number.isRequired,
  month: _react.PropTypes.number.isRequired,
  date: _react.PropTypes.number.isRequired
});


//////////////////
// WEBPACK FOOTER
// /usr/share/hubspot/build/.hubspot/static-archive/UIComponents/static-2.1552/js/types/SimpleDateTypes.js
// module id = 374
// module chunks = 0